<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="fromGettingStarted ? 'Add / Notify Pros' : 'Add Pros'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      @if (fromGettingStarted) {
        <div class="wizard-progress-bar">
          <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
        </div>
      }

      <!-- Step 1: Add Pros -->
      @if (currentStep === 1) {
        @if (fromGettingStarted) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Add Pros'" />
          </div>
        }
        @if (currentAddressName && currentPros.length > 0) {
          <tidy-alert class="black-background">
            <tidy-row>
              <tidy-text [header]="('Current Pros at ' | translate) + currentAddressName" />
            </tidy-row>
            <tidy-row>
              @for (pro of currentPros; track pro.id) {
                <tidy-text [body]="pro.name" />
              }
            </tidy-row>
          </tidy-alert>
        }
        <tidy-card>
          <tidy-card-button (action)="goToUploadPros()">
            <ion-row>
              <tidy-row class="vertical-align-center">
                <tidy-image [src]="'assets/img/csv.svg'" style="width: 20px" />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text [header]="'Upload Pros'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [body]="'Upload a CSV file with the names, emails, and phone numbers of the pros you want to add.'" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text [helper]="'or'" class="divider" />
        </tidy-row>
        @for (form of forms.controls; track form; let i = $index; let first = $first) {
          <tidy-card>
            <form [formGroup]="form">
              <tidy-row [ngClass]="first ? 'card-header vertical-align-center' : 'card-header'" [alignLastItemRight]="!first">
                <tidy-text [header]="('Pro #' | translate) + ((i | translate) + (1 | translate))" />
                @if (!first) {
                  <tidy-text
                    class="link red"
                    [body]="'Remove'"
                    (action)="removePro(form)" />
                }
              </tidy-row>
              <tidy-row>
                <tidy-input
                  formControlName="name"
                  [label]="'Pro Name'"
                  [form]="form.controls.name"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a name.'"
                  [icon]="'assets/svg/person.svg'" />
              </tidy-row>
              @if (windowService?.isDesktopRes) {
                <tidy-two-column-row>
                  <tidy-input
                    formControlName="email"
                    [label]="'Email'"
                    [form]="form.controls.email"
                    type="email"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a valid email or phone number.'"
                    [icon]="'assets/svg/mail.svg'" />
                  <tidy-input-international-phone
                    formControlName="phone"
                    [label]="'Phone'"
                    [form]="form.controls.phone"
                    [inputMode]="'numeric'"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a valid email or phone number.'"
                    [icon]="'assets/svg/phone-portrait.svg'"
                    [initialMask]="{ mask: '[00000000000000000000000]' }"
                    (countryCodeChange)="onCountryCodeChange($event, i)" />
                </tidy-two-column-row>
              }
              @if (!windowService?.isDesktopRes) {
                <tidy-row>
                  <tidy-input
                    formControlName="email"
                    [label]="'Email'"
                    [form]="form.controls.email"
                    type="email"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a valid email or phone number.'"
                    [icon]="'assets/svg/mail.svg'" />
                </tidy-row>
                <tidy-row>
                  <tidy-input-international-phone
                    formControlName="phone"
                    [label]="'Phone'"
                    [form]="form.controls.phone"
                    [inputMode]="'numeric'"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a valid email or phone number.'"
                    [icon]="'assets/svg/phone-portrait.svg'"
                    [initialMask]="{ mask: '[00000000000000000000000]' }"
                    (countryCodeChange)="onCountryCodeChange($event, i)" />
                </tidy-row>
              }
              <tidy-row>
                <tidy-select
                  #tidySelect
                  [icon]="'assets/svg/briefcase.svg'"
                  [label]="'Services Offered'"
                  [items]="serviceCategoryItems"
                  [form]="form.controls.serviceCategories"
                  formControlName="serviceCategories"
                  [multiple]="true"
                  [submitted]="submitted"
                  [errorMessage]="'Please select at least one service.'" />
              </tidy-row>
              <tidy-row [ngStyle]="{'margin-bottom': form?.value?.whereToAdd === 'select' ? '0px' : '-70px'}">
                <tidy-radio-button
                  class="horizontal-alignment no-wrap"
                  formControlName="whereToAdd"
                  [form]="form.controls.whereToAdd"
                  [items]="whereToAddItems"
                  [submitted]="submitted"
                  (optionChange)="selectWhereToAdd(form)" />
              </tidy-row>
              <div [ngStyle]="{ visibility: form?.value?.whereToAdd === 'select' ? 'visible' : 'hidden'}">
                <tidy-select
                  #tidySelect
                  [icon]="'assets/svg/home.svg'"
                  [label]="'Select Properties'"
                  [items]="propertiesToAddItems"
                  [form]="form.controls.propertiesToAdd"
                  formControlName="propertiesToAdd"
                  [multiple]="true"
                  [submitted]="submitted"
                  [errorMessage]="'Please select at least one property.'" />
              </div>
            </form>
          </tidy-card>
        }
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-text
            [actionBody]="'+ Add Another Pro'"
            class="link"
            (action)="pushEmptyForm()" />
        </tidy-row>
        <tidy-row class="align-right">
          @if (!fromGettingStarted) {
            <tidy-button
              [text]="'Skip'"
              [action]="boundSkipStep"
              class="secondary" />
          }
          <tidy-button
            [text]="fromGettingStarted ? 'Next' : (forms.controls.length > 0 ? ('Add Pros' | translate) : ('Add Pro' | translate))"
            class="primary"
            [action]="boundAddPros" />
        </tidy-row>
      }

      <!-- Step 2: Smart Numbers -->
      @if (currentStep === 2) {
        <div class="wizard-step-header">
          <tidy-text [title]="'Save Your Smart Numbers'" />
        </div>

        @if (loadingNumbers) {
          <div class="loading-container">
            <tidy-loader />
          </div>
        } @else {
          @if (proxyProNumber) {
            <tidy-row>
              <tidy-text
                [body]="'Save the numbers below to share with your pros and guests:'" />
            </tidy-row>
            <tidy-card>
              <tidy-row>
                <tidy-text
                  [header]="'Pro Smart Number'" />
              </tidy-row>
              <div class="proxy-copy-row">
                <div>
                  <tidy-text class="proxy-number" [header]="proxyProNumber" />
                </div>
                <div>
                  <img
                    class="proxy-copy-icon"
                    src="assets/icon/copy-circle-black.svg"
                    (click)="copyToClipboard(proxyProNumber)" />
                </div>
              </div>
              <tidy-row class="extra-top-padding">
                <tidy-text [body]="'How Pro Numbers Work'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'1. Share this with pros who you want to be able to message in.'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'2. As pros message in, they come into your Messages section.'" />
              </tidy-row>
            </tidy-card>
          }

          @if (proxyGuestNumber) {
            <tidy-card>
              <tidy-row>
                <tidy-text
                  [header]="'Guest Smart Number'" />
              </tidy-row>
              <div class="proxy-copy-row">
                <div>
                  <tidy-text class="proxy-number" [header]="proxyGuestNumber" />
                </div>
                <div>
                  <img
                    class="proxy-copy-icon"
                    src="assets/icon/copy-circle-black.svg"
                    (click)="copyToClipboard(proxyGuestNumber)" />
                </div>
              </div>
              <tidy-row class="extra-top-padding">
                <tidy-text [body]="'How Guest Numbers Work'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'1. Share this with guests, tenants, or anyone you want to be able message in.'" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'2. As guests message in, they come into your Messages section.'" />
              </tidy-row>
            </tidy-card>
          }

          @if (!proxyProNumber && !proxyGuestNumber) {
            <tidy-card>
              <tidy-row>
                <tidy-text
                  [body]="'Smart numbers require a paid subscription. You can set them up later.'" />
              </tidy-row>
            </tidy-card>
          }

          <div class="wizard-nav-row">
            <tidy-button
              [text]="'Next'"
              [action]="goToNextStep"
              class="primary" />
          </div>
        }
      }

      <!-- Step 3: Notify Pros -->
      @if (currentStep === 3) {
        <div class="wizard-step-header">
          <tidy-text [title]="'Notify Pros'" />
        </div>

        @if (!notifyLoaded) {
          <div class="loading-container">
            <tidy-loader />
          </div>
        } @else {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [body]="'We recommend sending your pros a short message notifying them of your changes. Use this to help craft a message:'" />
          </tidy-row>

          <tidy-card>
            <form [formGroup]="notifyForm">
              <tidy-row class="card-header">
                <tidy-text
                  [header]="'Craft Your Message'" />
              </tidy-row>
              <tidy-textarea
                label="Message for your pros"
                formControlName="messageText"
                [form]="notifyForm.controls.messageText" />
            </form>
          </tidy-card>

          <tidy-card>
            <tidy-row class="card-header">
              <tidy-text
                [header]="'Select How to Send'" />
            </tidy-row>
            <form [formGroup]="notifyForm">
              <tidy-radio-button
                [items]="howToSendItems"
                [form]="notifyForm.controls.howToSend"
                formControlName="howToSend" />
            </form>
            @if (notifyForm.value.howToSend == 'copy') {
              <tidy-row class="extra-top-padding">
                <tidy-text
                  [body]="'Copy Message'"
                  class="link"
                  (action)="copyMessage()" />
                @if (messageCopied) {
                  <tidy-text
                    style="margin-left:5px"
                    [helper]="'Copied'" />
                }
              </tidy-row>
            }
          </tidy-card>

          <tidy-card>
            <tidy-row class="card-header">
              <tidy-text
                [header]="'Select Pros to Send to'" />
            </tidy-row>
            <form [formGroup]="notifyForm">
              <tidy-radio-button
                [items]="proScopeItems"
                [form]="notifyForm.controls.proScope"
                formControlName="proScope" />
            </form>
            @if (notifyForm.value.proScope === 'select') {
              <div style="margin-top: 5px;"></div>
              @for (pro of allProItems; track pro.value) {
                <tidy-checkbox
                  [initValue]="true"
                  [items]="[{viewValue: pro.viewValue, value: true}]"
                  (checkedChange)="updateSelectedPros(pro)" />
              }
            }
          </tidy-card>

          @if (notifyForm.value.howToSend == 'sms') {
            <tidy-row class="align-right" style="margin-bottom: 10px;">
              @if (!fromGettingStarted) {
                <tidy-button
                  [text]="'Skip'"
                  [action]="skipNotifyStep"
                  class="secondary" />
              }
              <tidy-button
                [text]="'Send SMS to Pros'"
                [action]="sendSMSToPros"
                class="primary" />
            </tidy-row>
          }
          @if (notifyForm.value.howToSend == 'copy') {
            <tidy-row class="align-right" style="margin-bottom: 10px;">
              @if (!fromGettingStarted) {
                <tidy-button
                  [text]="'Skip'"
                  [action]="skipNotifyStep"
                  class="secondary" />
              }
              <tidy-button
                [text]="'Complete Step'"
                [action]="completeNotifyStep"
                class="primary" />
            </tidy-row>
          }

          @if (sendingInProgress) {
            <tidy-card>
              <tidy-row class="card-header">
                <tidy-text
                  [header]="'Sending messages to pros...'" />
              </tidy-row>
              <div class="pro-list">
                @for (item of prosSendStatus; track item.pro.value) {
                  <div class="pro-item">
                    <span class="pro-name">{{ item.pro.viewValue || 'Unknown Pro' }}</span>
                    <span class="pro-status" [ngClass]="'status-' + item.status">
                      @switch (item.status) {
                        @case ('pending') { ⏳ Waiting }
                        @case ('sending') { 📤 Sending... }
                        @case ('success') { ✅ Sent }
                        @case ('error') { ❌ Failed{{ item.error ? ': ' + item.error : '' }} }
                      }
                    </span>
                  </div>
                }
              </div>
            </tidy-card>
          }
        }
      }
    }

    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
